import classnames from "classnames";
import React from "react";
import { AlignedPeriod, PlanGrid } from "../models/plan-scale";
import styles from "./PlanDayHeader.module.scss";

interface PlanDayHeaderProps {
    /** Сетка: слоты (дни или недели), их раскладка и полная ширина */
    grid: PlanGrid;
    /** Месяцы, выровненные по границам слотов */
    periods: AlignedPeriod[];
    /** Слот, выделенный кликом по шапке */
    selectedSlot: number | null;
    onSelectSlot: (slot: number) => void;
}

/** Шапка сетки: полоса месяцев и слоты — номера рабочих дней либо недели */
export const PlanDayHeader: React.FC<PlanDayHeaderProps> = React.memo(
    ({ grid, periods, selectedSlot, onSelectSlot }) => {
    // граница месяцев идёт сквозь всю таблицу, включая полосу слотов
    const monthBreaks = periods.slice(1).map((period) => period.left);
    const byWeek = grid.scale === "week";

    return (
        <div className={styles.header}>
            <div className={styles.months}>
                <div className={styles.name} />
                {periods.map((aligned) => (
                    <div
                        key={`${aligned.period.year}_${aligned.period.month}`}
                        className={styles.month}
                        style={{ width: aligned.width }}
                    >
                        {aligned.period.name} {aligned.period.year}
                        <span className={styles.norm}>
                            {aligned.period.workDaysCount}&nbsp;({aligned.period.workHours}&nbsp;ч)
                        </span>
                    </div>
                ))}
            </div>

            <div className={styles.days}>
                <div className={styles.name} />
                <div className={styles.track} style={{ width: grid.totalWidth }}>
                    {grid.slots.map((slot, index) => (
                        <div
                            key={slot.left}
                            className={classnames(styles.day, {
                                [styles.week]: byWeek,
                                [styles.past]: slot.isPast,
                                [styles.today]: slot.isToday,
                                [styles.empty]: slot.isEmpty,
                                [styles.selected]: index === selectedSlot && !slot.isEmpty,
                            })}
                            style={{ left: slot.left, width: slot.width }}
                            title={
                                slot.isEmpty ? slot.title : `${slot.title} — выделить у всех сотрудников`
                            }
                            onClick={() => onSelectSlot(index)}
                        >
                            {slot.label}
                        </div>
                    ))}

                    {monthBreaks.map((left) => (
                        <div key={left} className={styles.monthBreak} style={{ left }} />
                    ))}
                </div>
            </div>
        </div>
    );
    }
);

PlanDayHeader.displayName = "PlanDayHeader";
